import { finalize, map } from 'rxjs/operators';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe, ElementRef, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsDto, NewsImportanceType, NewsServiceProxy, GetNewsForViewDto, MediaLibraryServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { BrowserModule } from '@angular/platform-browser'
import {DataView, DataViewModule} from 'primeng/dataview';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent, SelectItem,PrimeNGConfig } from 'primeng/api';
import {  result } from 'lodash-es';
import { appModuleAnimation } from '@shared/animations/routerTransition';
@Component({
    selector: 'seek-news-list',
    templateUrl: './news-list.component.html',
    styleUrls: ['./news-list.component.scss'],
    animations: [appModuleAnimation()]
})
export class NewsListComponent extends AppComponentBase implements OnInit,AfterViewInit {
    sortOptions: SelectItem[];
    sortOrder: number;
    sortKey: string;
    sortField: string;
    TotalNewsCount=10;
    newsList: Array<GetNewsForViewDto>;
    Loading= false;
    constructor(injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _newsServiceProxy: NewsServiceProxy,
        private _mediaLibraryProxy: MediaLibraryServiceProxy,
        private _primengConfig: PrimeNGConfig,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);

    }

    ngOnInit() {

        this.sortOptions = [
            {label: 'Publishdate High to Low', value: 'publishStateDate asc'},
            {label: 'Publishdate Low to High', value: 'publishStateDate desc'}
        ];

        this._primengConfig.ripple = true;
    }
    ngAfterViewInit(){
        this.cdr.detectChanges();
    }
    loadNews(event?: LazyLoadEvent)
    {
       this.Loading=true;
        this._newsServiceProxy.getAllPublishedNews('', undefined,this.sortField,event.first,this.TotalNewsCount).pipe(finalize(() => {

         })).subscribe((result) => {

            this.Loading=false;
            this.newsList=result.items;
            this.TotalNewsCount=result.totalCount;

        });
    }
    onSortChange(event) {
        let value = event.value;

        if (value.indexOf('asc') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        }
        else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

}
